// eslint-disable-next-line @typescript-eslint/no-var-requires
const pino = require('pino')

const logger = pino({
  level: process.env.LOG_LEVEL || 'debug',
  nestedKey: 'detail',
  formatters: {
    level(label) {
      return { level: label }
    },
  },
})

const timers = new Map()

logger.time = (label) => {
  timers.set(label, Date.now())
}

logger.timeEnd = (label) => {
  const startTime = timers.get(label)
  if (startTime) {
    const duration = ((Date.now() - startTime) / 1000).toFixed(2)
    logger.info(`\x1b[31mTime Report: ${label} took ${duration} seconds\x1b[0m`)
    timers.delete(label)
  }
}

module.exports = logger
